var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup321(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_55",
    "data-name": "Ellipse 55",
    cx: 11,
    cy: 11,
    r: 11,
    transform: "translate(1450 520)",
    fill: "#0f203f"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32",
    transform: "translate(-1450 -520)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    cx: 11,
    cy: 11,
    r: 11,
    transform: "translate(1450 520)",
    fill: "#0f203f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_7",
    "data-name": "Mask Group 7",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14734",
    "data-name": "Path 14734",
    d: "M0,18.994a3.734,3.734,0,0,1,.845-.521c1.318-.657,2.633-1.322,3.957-1.968a1.655,1.655,0,0,0,1.062-1.633c-.013-.412,0-.825,0-1.238a.439.439,0,0,0-.1-.3,8.117,8.117,0,0,1-1.566-2.957.436.436,0,0,0-.173-.247A1.242,1.242,0,0,1,3.49,9.091c0-.556,0-1.112,0-1.668a1.176,1.176,0,0,1,.348-.856A.454.454,0,0,0,3.973,6.2c-.01-.842-.028-1.684-.016-2.526A3.175,3.175,0,0,1,6.208.545,8.374,8.374,0,0,1,12.266.59a3.228,3.228,0,0,1,2.139,3.25c-.036.816-.01,1.634-.016,2.45a.323.323,0,0,0,.108.246,1.254,1.254,0,0,1,.376.924c0,.539.006,1.078,0,1.617a1.268,1.268,0,0,1-.85,1.225.394.394,0,0,0-.236.254,8.8,8.8,0,0,1-1.655,2.78.42.42,0,0,0-.111.3c0,.463,0,.927,0,1.39a1.581,1.581,0,0,0,1.029,1.494l4.376,2a2.857,2.857,0,0,1,.777.475Z",
    transform: "translate(1452 523.006)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_56",
    "data-name": "Ellipse 56",
    transform: "translate(1450 520)",
    fill: "none",
    stroke: "#0f203e",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 10.75,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup321);
export default __webpack_public_path__ + "static/media/Group 32 (1).fac4ecb371bd306f381747a980f0c257.svg";
export { ForwardRef as ReactComponent };